<template>
  <div>
    <v-tabs v-model="tabValue">
      <v-tab href="#tab-1">待倉管處理 </v-tab>
      <v-tab href="#tab-2">待業務處理 </v-tab>
      <v-tab href="#tab-3">轉拋/作廢 </v-tab>
      <v-tab-item value="tab-1">
        <stock-transfer-order :tabValue="tabValue" />
      </v-tab-item>
      <v-tab-item value="tab-2">
        <sale-transfer-order :tabValue="tabValue" />
      </v-tab-item>
      <v-tab-item value="tab-3">
        <done-transfer-order :tabValue="tabValue" />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import DoneTransferOrder from '@/components/TransferOrder/DoneTransferOrder.vue'
import StockTransferOrder from '@/components/TransferOrder/StockTransferOrder.vue'
import SaleTransferOrder from '@/components/TransferOrder/SaleTransferOrder.vue'
export default {
  components: { DoneTransferOrder, StockTransferOrder, SaleTransferOrder },
  name: 'TransferOrder',
  data: () => ({
    tabValue: 'tab-1'
  }),
  mounted () {},
  watch: {},
  computed: {},
  methods: {}
}
</script>
